/**
 * Malaysian phone normalization (doc 06 §3.4). One canonical form feeds every writer
 * (Meta webhooks, store webhooks, CSV import, manual entry): wa_id digits, no '+',
 * leading 0 → 60. Stored form must satisfy the DB CHECK `^[0-9]{8,15}$` (doc 03).
 */
export function normalizeMyPhone(raw) {
    let digits = (raw ?? "").replace(/\D/g, "");
    if (!digits)
        return null;
    if (digits.startsWith("0")) {
        digits = `60${digits.slice(1)}`; // local 01X… → 601X…
    }
    else if (digits.startsWith("60")) {
        // already country-coded
    }
    else if (digits.startsWith("1")) {
        digits = `60${digits}`; // bare mobile 1X… → 601X…
    }
    else {
        return null; // not a recognisable MY number
    }
    // Malaysian mobile canonical: 60 + 1 + 8–9 digits (e.g. 60123456789).
    return /^601\d{7,9}$/.test(digits) ? digits : null;
}
/** Pretty render for display only — never stored (doc 03 §1). */
export function prettyMyPhone(canonical) {
    const m = /^60(\d{2})(\d{3,4})(\d{4})$/.exec(canonical);
    return m ? `+60 ${m[1]}-${m[2]} ${m[3]}` : `+${canonical}`;
}
//# sourceMappingURL=phone.js.map